module.exports = __webpack_public_path__ + "static/media/myAvatar.fa5fc5d2.png";